import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import ResetPasswordModal from './ResetPasswordModal';
import useAuthStore from '../store/authStore';
import './Layout.css';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      {user?.isFirstLogin && <ResetPasswordModal />}
      <Sidebar />
      <main className="main-content">
        <div className="top-bar">
          <div className="user-info-bar">
            <span className="user-name">{user?.name || 'User'}</span>
            <span className="user-role-badge">{user?.role || 'Developer'}</span>
          </div>
          <div className="top-bar-actions">
            <button className="btn-logout" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
};

export default Layout;